module.exports = __webpack_public_path__ + "img/Gkash.3df2d63a.png";